import Airtable from "airtable";

let url = new URL(window.location.href);
let baseUrl = url.origin;
let baseID;


if(baseUrl === "https://production.d1kir5c0e4cr89.amplifyapp.com" || baseUrl === "https://etractorworld.com"){
  baseID = "appyndUA2QiIMMJJq"
}else{
  baseID = "appfTOfjqxfHNrr5G"
}

export const base = new Airtable({
  apiKey: "keyQuVTW0rl8YalmM",
}).base(baseID);


export const digitalBase = new Airtable({
  apiKey: "keyazRkTxiKMkxebe",
}).base("appGfgHtDxAfgz4vQ");


export const MfsBase = new Airtable({
  apiKey: "keyQuVTW0rl8YalmM",
}).base("appO6d1aFLorZVYhP");



